// Baut ein Liste-Item (Autocomplete/Flatlist) aus einem Liegenschafts-/Bauteil-Objekt.
export function toRealestateFlatItem(item) {
    return {
        name: item.name,
        id: item.id,
        guid: item.guid,
        title: item.number + ' - ' + item.name,
        key: item.guid,
    };
}
